import { flatten, get, drop, findIndex, uniqBy, concat, omit } from 'lodash-es'
import { createQueryDsl, dayjsInit } from '@ow/utils'

const remoteableTypes = ['user', 'org', 'area', 'standard']
const filterTypes = ['slateRichText']

// 新旧版本|| data
export const parseFormDefs = (data) => {
  const { tbNodes, tableNodes, tableNodeDefs } = data
  const nodes = tbNodes || tableNodes || tableNodeDefs || data
  if (nodes) {
    const arr = uniqBy(
      nodes.filter(
        (node) => !(node.viewDef && filterTypes.includes(node.viewDef.type))
      ),
      (x) => x.slug
    )

    return arr.map((node) => {
      const { viewDef = {} } = node
      // 对 locationWithLngLat 特殊处理
      if (viewDef.type === 'locationWithLngLat') {
        viewDef.type = 'geolocation'
      }

      if (viewDef.type === 'newRef') {
        viewDef.type = 'ref'
        viewDef.table = true
      }
      // if (viewDef.type === 'ref') {
      //   viewDef.type = 'sysref'
      //   viewDef.tbId = viewDef.dataFromTbId
      // }
      if (viewDef.type === 'refMultiple') {
        viewDef.type = 'ref'
        viewDef.multiple = true
        viewDef.tbId = viewDef.dataFromTbId
      }
      // 对几个类型让他们默认从远端获取数据
      if (remoteableTypes.includes(viewDef.type)) {
        if (viewDef.remoteable !== false) {
          viewDef.remoteable = true
        }
      }
      // 整合字段
      if (viewDef.type === 'product') {
        const { productSlugs } = viewDef
        viewDef.productFields = arr.filter((v) => {
          return productSlugs.includes(v.viewDef.slug)
        })
      }
      return {
        ...viewDef,
        slug: node.slug,
      }
    })
  }
  return []
}

// 前端传给后端的数据的转换,应区分新建、编辑
const filterFiledType = ['locationWithText', 'slateRichText']
export const transformField = (filed, fileds) => {
  if (
    filterFiledType.includes(filed.type) ||
    (filed.type === 'text' && filed.slug.indexOf('_otherSelect') > -1)
  ) {
    return []
  }
  // 地理位置
  if (filed.type === 'geolocation') {
    return [
      {
        slug: filed.slug,
        useViewDef: true,
        viewDef: { ...filed, type: 'locationWithLngLat' },
      },
      {
        useViewDef: true,
        slug: filed.slug + '_text',
        viewDef: {
          ...filed,
          required: false,
          slug: filed.slug + '_text',
          type: 'locationWithText',
        },
      },
    ]
  }

  // 富文本
  if (filed.type === 'richText') {
    return [
      {
        useViewDef: true,
        viewDef: filed,
        slug: filed.slug,
      },
      {
        useViewDef: true,
        slug: filed.slug + '_slateRichText',
        viewDef: {
          ...filed,
          required: false,
          slug: filed.slug + '_slateRichText',
          type: 'slateRichText',
        },
      },
    ]
  }

  if (filed.type === 'dropSelect' || filed.type === 'select') {
    const targetSlug = filed.slug + '_otherSelect'
    const targetSlugOtherSelects = filed.slug + '_otherSelects'

    if (filed.etc) {
      const res = [
        {
          useViewDef: true,
          viewDef: filed,
          slug: filed.slug,
        },
        {
          useViewDef: true,
          slug: targetSlug,
          viewDef: {
            ...omit(filed, ['selfRefSlug', 'ownViewDef', 'isBindStandard']),
            required: false,
            slug: targetSlug,
            type: 'text',
            hidden: true,
          },
        },
      ]
      const isTargetSlugOthersExist = fileds.filter(
        (item) => item.slug === targetSlugOtherSelects
      )
      if (isTargetSlugOthersExist.length === 0) {
        res.push({
          useViewDef: true,
          slug: targetSlugOtherSelects,
          viewDef: {
            ...omit(filed, ['selfRefSlug', 'ownViewDef', 'isBindStandard']),
            required: false,
            slug: targetSlugOtherSelects,
            type: 'array',
            hidden: true,
          },
        })
      }
      return res
    }
  }

  if (filed.type === 'ref') {
    return {
      useViewDef: true,
      viewDef: {
        type: filed.multiple ? 'refMultiple' : 'newRef',
        dataFromTbId: filed.tbId,
        title: filed.title || filed.name,
        slug: filed.slug,
      },
      slug: filed.slug,
      dataFromTbId: filed.tbId,
    }
  }
  if (filed.type === 'lookup') {
    return {
      useViewDef: true,
      viewDef: {
        lookupSlug: filed.lookupSlug,
        refSlug: filed.refSlug,
        slug: filed.slug,
        title: filed.title,
        type: 'lookup',
      },
      slug: filed.slug,
    }
  }

  // if (filed.type === 'sysref') {
  //   return {
  //     useViewDef: true,
  //     viewDef: {
  //       ...filed,
  //       // title: filed.title || filed.tbName,
  //       type: 'ref',
  //       // tbAppId: filed.resId,
  //       // dataFromTbId: filed.tbId,
  //       // lookupSlug: null,
  //       // slugUseDescription: null,
  //     },
  //     nodeTemplateId: filed.nodeTemplateId,
  //     dataFromTbId: filed.tbId,
  //     uuid: filed.uuid,
  //     slug: filed.slug,
  //   }
  // }

  return {
    useViewDef: true,
    viewDef: filed,
    slug: filed.slug,
  }
}

export const transformFields = (fileds) => {
  return flatten(
    (fileds || []).map((field) => {
      return transformField(field, fileds)
    })
  )
}

const forbidNavMenuTypes = ['tabs', 'fixedFilters', 'pagination']
const recycleLayouts = {
  navMenu: {
    elements: [
      {
        rightElements: [
          {
            type: 'linkButton',
            actionType: 'recycle',
          },
        ],
      },
    ],
  },
  elements: [
    {
      type: 'boxing',
      leftElements: [],
      rightElements: [
        {
          type: 'fixedFilters',
        },
      ],
    },
    {
      elements: [
        {
          type: 'list',
          actionType: 'listConfig',
        },
      ],
      footerElement: {
        type: 'boxing',
        leftElements: [
          {
            type: 'linkButton',
            actionType: 'recovery',
          },
        ],
        rightElements: [
          {
            type: 'pagination',
          },
        ],
      },
    },
  ],
}
const transformLayouts = (currentLayouts = {}) => {
  const layouts = currentLayouts.layouts || currentLayouts
  const { navMenu = {}, elements = [] } = layouts || {}
  const arr = get(navMenu, 'elements', [])
  // 如果navmenu配置了数据
  // if (!elements || !elements.length || arr.length) {
  //   return layouts
  // }

  // const isNavMenuHasData = !elements || !elements.length || arr.length

  // 如果navmenu没有配置数据，目前只有设置right/leftElements 的可以合并到navMenu

  const types =
    !arr.length && elements && elements.length
      ? concat(
          get(elements[0], 'leftElements', []),
          get(elements[0], 'rightElements', [])
        ).map((v) => v.type)
      : []

  const isCanMergeNavMenu =
    types.length && !types.find((v) => forbidNavMenuTypes.includes(v))

  // 判断一下分页与list
  const indexTable = findIndex(
    elements,
    (e) => e.elements && e.elements.length && e.elements[0].type === 'list'
  )

  const tableElement = elements[indexTable]

  if (indexTable < elements.length - 1 && tableElement) {
    // 有分页和批量操作
    tableElement.footerElement = elements[indexTable + 1]
  }

  const finalElements = tableElement
    ? elements
        .map((item, index) => {
          if (index === indexTable) {
            return tableElement
          }
          if (index === indexTable + 1) {
            return null
          }
          return item
        })
        .filter((v) => v)
    : elements

  const _currentLayouts = isCanMergeNavMenu
    ? {
        navMenu: { ...navMenu, elements: [finalElements[0]] },
        ...layouts,
        elements: drop(finalElements),
      }
    : { ...layouts, elements: finalElements }

  return currentLayouts.recycleLayouts
    ? { ...currentLayouts, layouts: _currentLayouts }
    : { recycleLayouts, layouts: _currentLayouts }
}

const transformOperatorConfig = (operatorConfig) => {
  return operatorConfig && operatorConfig.recycle
    ? operatorConfig
    : {
        operatorConfig,
        recycle: {
          elements: [
            {
              type: 'linkButton',
              actionType: 'detailConfig',
            },
            {
              type: 'linkButton',
              actionType: 'recoveryConfig',
            },
          ],
        },
      }
}

/**
 * 反转对象的key / value
 * @param {*} obj
 * @returns
 */
const objectFlip = (obj) => {
  const ret = {}
  Object.keys(obj).forEach((key) => {
    ret[obj[key]] = key
  })
  return ret
}

// 用于构造服务端查询数据的参数
export const buildQueries = (viewConfig) => {
  if (!viewConfig) {
    return {}
  }
  const { filters, sorts, fields } = viewConfig
  const { orders, query = {} } = createQueryDsl(filters, sorts)

  // console.log('[order & query]', order, query)

  const body = {}
  if (orders) {
    body.orders = orders
  }
  if (fields && fields.length > 0) {
    body.returnSlugs = fields
  }
  return {
    ...body,
    ...query,
  }
}

// 用于批量编辑数据转换
export const transformerBatchEditData = (data) => {
  const { slugs, datas, objectIds } = data

  return objectIds.map((v) => {
    return { objectId: v, map: datas, shouldUpdateSlugs: slugs }
  })
}

// 视图重复
const parseViewType = {
  // 1 列表视图list 2 看板视图 3 大表 4 日历视图 5 地图视图 6 文章视图
  1: 'list',
  2: 'board',
  3: 'matrix',
  4: 'calendar',
  // 3: 'gallery',
  5: 'map',
  6: 'article',
  7: 'file',
  8: 'chart',
  9: 'media',
  10: 'export-map',
}

const transformViewType = {
  // 1 列表视图list 2 看板视图 3 画廊视图 4 日历视图 5 地图视图 6 文章视图
  list: 1,
  board: 2,
  matrix: 3,
  // 3: 'list',
  calendar: 4,
  // 3: 'gallery',
  map: 5,
  article: 6,
  file: 7,
  chart: 8,
  media: 9,
  'export-map': 10,
}

const defaultLayouts = {
  // 需显示在导航处的布局
  navMenu: {
    elements: [
      {
        type: 'unboxing',
        leftElements: [
          // {
          //   type: 'text',
          //   actionType: 'title',
          // },
        ],
        rightElements: [
          {
            type: 'linkButton',
            actionType: 'collector',
          },
        ],
      },
    ],
  },
  elements: [
    {
      type: 'boxing',
      leftElements: [],
      rightElements: [
        {
          type: 'fixedFilters',
        },
      ],
    },
    {
      type: 'unboxing',
      elements: [
        {
          type: 'list',
          actionType: 'listConfig',
        },
      ],
    },
    {
      type: 'unboxing',
      leftElements: [],
      rightElements: [
        {
          type: 'pagination',
        },
      ],
    },
  ],
}

const transformFilters = (filters) => {
  if (!filters) {
    return {}
  }
  const { queries = [] } = filters || {}
  const arr = [...queries]
  arr.forEach((v, i) => {
    if (v.valueFlag === 'currentDate') {
      arr.splice(i, 1, {
        ...v,
        value: new Date(new Date().toLocaleDateString()),
      })
    } else if (v.valueFlag === 'currentMonth') {
      arr.splice(i, 1, {
        ...v,
        value: {
          startDate: dayjsInit().startOf('month').toDate(),
          endDate: dayjsInit().endOf('month').toDate(),
        },
      })
    }
  })
  return { ...filters, queries: arr }
}

export const transformView = (view, tbId) => {
  const {
    sorts,
    filters,
    title,
    viewType,
    color,
    group,
    rowHeight,
    columnsConfig,
    selectedButtons,
    devButtons,
    buttons,
    hidden,
    articleMap,
    fileMap,
    filelistConfig,
    listConfig,
    mapConfig,
    fixedFilters,
    layouts,
    ProjectConfig,
    detailConfig,
    deleteConfig,
    reviewConfig,
    editorConfig,
    importerConfig,
    exporterConfig,
    exporterStatisticsConfig,
    reporterConfig,
    collectorConfig,
    duplicateConfig, // 复制案件
    bigTableConfig,
    matrixConfig,
    articleConfig,
    mediaConfig,
    recycleConfig,
    punchInConfig,
    allowUploadArea,
    message,
    operatorConfig,
    mark,
    pageSize,
    appConfig,
    statisticsConfig,
    fileConfig,
    standardConfig,
    statusConfig,
    waterMarkDefs,
  } = view

  const orderAndShowTypes = (columnsConfig || []).map((v) => {
    if (v.slug === 'tableDataId') {
      return {
        slug: v.slug,
        nodeTemplateId: v.nodeTemplateId,
        showType: 'sticky',
      }
    }
    return {
      slug: v.slug,
      nodeTemplateId: v.nodeTemplateId,
      showType: v.showType || 'show',
    }
  })

  const props = {
    tbId,
  }
  const extData = {}
  if (title) {
    props.name = title
  }
  if (viewType) {
    props.viewType = transformViewType[viewType]
  }
  if (listConfig && listConfig.fields && listConfig.fields.length) {
    extData.columnsConfig = listConfig.fields
    props.extData = extData
  } else if (columnsConfig) {
    extData.columnsConfig = columnsConfig
    props.orderAndShowTypes = orderAndShowTypes
    props.extData = extData
  }
  if (fixedFilters) {
    extData.fixedFilters = fixedFilters
    props.extData = extData
  }
  if (color) {
    extData.color = color
    props.extData = extData
  }
  if (group) {
    extData.group = group
    props.extData = extData
  }
  if (rowHeight) {
    extData.rowHeight = rowHeight
    props.extData = extData
  }
  if (sorts) {
    extData.sorts = sorts
    props.orderDslForSpecial = sorts
    props.extData = extData
  }
  if (filters) {
    extData.filters = filters
    extData.defaultFilters = filters
    props.queryDslForSpecial = filters
    props.extData = extData
  }

  if (selectedButtons) {
    extData.selectedButtons = selectedButtons
    props.extData = extData
  }

  if (devButtons) {
    extData.devButtons = devButtons
    props.extData = extData
  }

  if (buttons) {
    extData.buttons = buttons
    props.extData = extData
  }

  if (hidden) {
    extData.hidden = hidden
    props.extData = extData
  }

  if (importerConfig) {
    extData.importerConfig = importerConfig
    props.extData = extData
  }

  if (collectorConfig) {
    extData.collectorConfig = collectorConfig
    props.extData = extData
  }

  if (duplicateConfig) {
    extData.duplicateConfig = duplicateConfig
    props.extData = extData
  }

  if (matrixConfig) {
    extData.matrixConfig = matrixConfig
    props.extData = extData
  }

  // 兼容
  if (bigTableConfig) {
    extData.bigTableConfig = bigTableConfig
    props.extData = extData
  }

  if (exporterConfig) {
    extData.exporterConfig = exporterConfig
    props.extData = extData
  }

  if (punchInConfig) {
    extData.punchInConfig = punchInConfig
    props.extData = extData
  }

  if (exporterStatisticsConfig) {
    extData.exporterStatisticsConfig = exporterStatisticsConfig
    props.extData = extData
  }

  if (reporterConfig) {
    extData.reporterConfig = reporterConfig
    props.extData = extData
  }
  if (articleMap) {
    extData.articleMap = articleMap
    props.extData = extData
  }

  if (articleConfig) {
    extData.articleConfig = articleConfig
    props.extData = extData
  }
  if (detailConfig) {
    extData.detailConfig = detailConfig
    props.extData = extData
  }
  if (fileMap) {
    extData.fileMap = fileMap
    props.extData = extData
  }
  if (filelistConfig) {
    extData.filelistConfig = filelistConfig
    props.extData = extData
  }
  if (fixedFilters) {
    extData.fixedFilters = fixedFilters
    props.extData = extData
  }
  if (listConfig) {
    extData.listConfig = listConfig
    props.extData = extData
  }
  if (mediaConfig) {
    extData.mediaConfig = mediaConfig
    props.extData = extData
  }
  if (mapConfig) {
    extData.mapConfig = mapConfig
    props.extData = extData
  }

  if (deleteConfig) {
    extData.deleteConfig = detailConfig
    props.extData = extData
  }

  if (reviewConfig) {
    extData.reviewConfig = reviewConfig
    props.extData = extData
  }

  if (appConfig) {
    extData.appConfig = appConfig
    props.extData = extData
  }

  if (editorConfig) {
    extData.editorConfig = editorConfig
    props.extData = extData
  }
  if (layouts) {
    extData.layouts = layouts
    props.extData = extData
  }
  if (!layouts) {
    extData.layouts = defaultLayouts
    props.extData = extData
  }
  if (allowUploadArea) {
    extData.allowUploadArea = allowUploadArea
    props.extData = extData
  }
  if (message) {
    extData.message = message
    props.extData = extData
  }
  if (operatorConfig) {
    extData.operatorConfig = operatorConfig
    props.extData = extData
  }
  if (recycleConfig) {
    extData.recycleConfig = recycleConfig
    props.extData = extData
  }
  if (ProjectConfig) {
    extData.ProjectConfig = ProjectConfig
    props.extData = extData
  }
  if (pageSize) {
    extData.pageSize = pageSize
    props.extData = extData
  }
  if (mark) {
    extData.mark = mark
    props.extData = extData
  }
  if (ProjectConfig) {
    extData.ProjectConfig = ProjectConfig
    props.extData = extData
  }
  if (statisticsConfig) {
    extData.statisticsConfig = statisticsConfig
    props.extData = extData
  }
  if (fileConfig) {
    extData.fileConfig = fileConfig
    props.extData = extData
  }
  if (standardConfig) {
    extData.standardConfig = standardConfig
    props.extData = extData
  }
  if (statusConfig) {
    extData.statusConfig = statusConfig
    props.extData = extData
  }
  if (waterMarkDefs) {
    extData.waterMarkDefs = waterMarkDefs
    props.extData = extData
  }
  // 处理navMenu
  return props
}

export const parseView = (view) => {
  const viewRes = {
    id: view.id,
    title: view.name,
    mark: view.extData ? view.extData.mark : '',
    layouts: view.extData
      ? transformLayouts(view.extData.layouts)
      : defaultLayouts,
    operatorConfig: view.extData
      ? transformOperatorConfig(view.extData.operatorConfig)
      : {},
    statusConfig: view.extData ? view.extData.statusConfig : {},
    detailConfig: view.extData ? view.extData.detailConfig : {},
    fixedFilters: view.extData ? view.extData.fixedFilters : {},
    filters: view.extData ? transformFilters(view.extData.filters) : {},
    defaultFilters: view.extData ? transformFilters(view.extData.filters) : {},
    collectorConfig: view.extData ? view.extData.collectorConfig : {},
    duplicateConfig: view.extData ? view.extData.duplicateConfig : {},
    bigTableConfig: view.extData ? view.extData.bigTableConfig : {},
    matrixConfig: view.extData ? view.extData.matrixConfig : {},
    importerConfig: view.extData ? view.extData.importerConfig : {},
    punchInConfig: view.extData ? view.extData.punchInConfig : {},
    exporterConfig: view.extData
      ? view.extData.exporterConfig
      : { expoterAll: false, exporterChecked: false },
    exporterStatisticsConfig: view.extData
      ? view.extData.exporterStatisticsConfig
      : {},
    reporterConfig: view.extData ? view.extData.reporterConfig : {},
    pageSize: view.extData ? view.extData.pageSize : 50,
    fileMap: view.extData ? view.extData.fileMap : {},
    filelistConfig: view.extData ? view.extData.filelistConfig : {},
    allowDetail: view.extData ? view.extData.allowDetail : {},
    articleMap: view.extData ? view.extData.articleMap : {},
    articleConfig: view.extData ? view.extData.articleConfig : {},
    mapConfig: view.extData ? view.extData.mapConfig : {},
    listConfig: view.extData ? view.extData.listConfig : {},
    mediaConfig: view.extData ? view.extData.mediaConfig : {},
    fileConfig: view.extData ? view.extData.fileConfig : {},
    standardConfig: view.extData ? view.extData.standardConfig : {},
    reviewConfig: view.extData ? view.extData.reviewConfig : {},
    editorConfig: view.extData ? view.extData.editorConfig : {},
    deleteConfig: view.extData ? view.extData.deleteConfig : {},
    // 原有的
    allowUploadArea: view.extData ? view.extData.allowUploadArea : {},
    recycleConfig: view.extData ? view.extData.recycleConfig : {},
    ProjectConfig: view.extData ? view.extData.ProjectConfig : {},
    appConfig: view.extData ? view.extData.appConfig : {},
    viewType: parseViewType[view.viewType],
    color: view.extData ? view.extData.color : {},
    group: view.extData ? view.extData.group : {},
    hidden: view.extData && view.extData.hidden,
    sorts: view.extData ? view.extData.sorts : {},
    rowHeight: view.extData ? view.extData.rowHeight : 32,
    tbId: view.tbId,
    columnsConfig: view.extData ? view.extData.columnsConfig : [],
    statisticsConfig: view.extData ? view.extData.statisticsConfig : [],
    waterMarkDefs: view.extData ? view.extData.waterMarkDefs : [],
    // message: view.extData ? view.extData.message : {},
  }

  if (view.extData) {
    // if (view.extData.createBtn) {
    //   viewRes.createBtn = view.extData.createBtn
    // }

    // if (view.extData.editBtn) {
    //   viewRes.editBtn = view.extData.editBtn
    // }

    if (view.extData.buttons) {
      viewRes.buttons = view.extData.buttons
    }

    if (view.extData.selectedButtons) {
      viewRes.selectedButtons = view.extData.selectedButtons
    }
  }

  return viewRes
}

// 测试环境项目id
const devAppId = {
  wz: 970, // 无证无照经营整治第三方核查项目
  zt: 971, // 西城区建筑垃圾协同管理执法系统(渣土)
  ugm: 957, // 北京市垃圾分类日常运行检查项目
  lhzf: 971, // 西城区建筑垃圾协同管理执法系统(联合执法)
  jzlj: 971, // 西城区建筑垃圾协同管理执法系统(联合执法)
  yyzcjc: 973, // 政策监测及政策数据库搭建项目(远洋)
  zrzh: 974, // 内蒙土默特右旗自然灾害风险普查系统
  ydspxj: 975, // 移动视频巡检
  rzsb: 976, // 日志上报系统
  yldzhtgl: 978, // 北京市通州区永乐店镇合同管理系统
  cyhjjc: 979, // 朝阳环境检查项目
  wbhjjc: 980, // 2022年公司外部环境监测与分析
  xcfz: 981, // 西城辅助项目
  mggf: 982, // 美国国防采办数据监测分析系统
  ddqljfl: 983, // 大东区垃圾分类全链路智慧化管理平台
  mbyxm: 985, // 模版一项目
  mbexm: 986, // 模版二项目
  mbsxm: 987, // 模版三项目
  cthcp: 989, // 密云区2022年全国文明城区创建常态化测评项目
  dsfxcfw: 991, // 2021年疏解整治促提升第三方巡查服务
  zjzsjcpt: 992, // 国际政界指数监测平台
  wsjdjc: 995, // 北京市行业环境卫生监督检查-农村公厕
  ddmpt: 998, // 低代码平台
  filter: 999, // 通用筛选项项目
  lstl: 1000, // 2022年莱绅通灵神访稽核项目
  pgcxhjjs: 1001, // 2022年平谷区城乡环境建设咨询服务项目
  syhjws: 1003, // 沈阳市环境卫生监管系统
  cypystl: 1005, // 朝阳区平原生态林检查项目（2022）
  cphczjc: 1007, // 昌平区河长制检查
  dlljfl: 1006, // 大连市城市生活垃圾分类检查考核智慧管理平台(历史数据)
  sgwzdbg: 1008, // 市管委自动报告
  dlljflxzsj: 1009, // 大连市城市生活垃圾分类检查考核智慧管理平台(新增数据)
  tyzrzh: 1010, // 第一次自然灾害普查县级应用系统
  qjzhyl: 1011, // 曲靖市智慧园林全体系工作管理平台
  zjzhgl: 1013, // 湛江市创建全国文明城市智慧管理项目
  'zjzhgl-wmsjzx': 1013, // 湛江市文明实践中心
  'zjzhgl-hrhs': 1013, // 湛江市道德模范与好人好事
  'zjzhgl-dwgl': 1013, // 湛江市单位管理
  hrwmcq: 1014, // 怀柔区2022年创建全国文明城区项目
  tdqs: 1015, // 天大求实项目管理
  tdqsback: 1015, // 天大求实项目管理
  wmcq: 1016, // 西城区文明城区建设自检系统
  rxsq: 1017, // 北京市管委热线诉求分析（拟定
  jsjb: 1032, // 接诉即办大数据分析服务其他专业技术服务采购项目
  cyzxjc: 1035, // 2022年朝阳区环境专项检查
  qzewm: 1037, // 全总二维码
  'ljfl-xq': 1038, // 垃圾分类示范片区复验和部分示范片区二次验收服务-小区
  lzzrzh: 1050, // 潞州区应急管理局第一次全国自然灾害综合风险普查项目
  zzpczz: 1051, // 郑州市房屋建筑安全隐患排查整治系统
  xcljfl: 1053, // 2022年西城区垃圾分类日常检查项目
  jlljfl: 1055, // 净绿垃圾分类
  sjswmsjzx: 1058, // 石景山文明实践中心
  gxdw: 1059, // 广西电网基于设备风险管控与隐患治理
  ljfldemo: 1061, // 清研垃圾分类全链路智慧管理平台
  fwzljc: 1060, // （技术内部）2022年服务业服务质量监测评价项目
  dbys: 1066, // 大表演示
  ftstl: 1068, // 丰台区生态林管护经营系统
  xczhxc: 1067, // 西城区限额以下工程综合巡查管理系统
  cyzhdd: 1069, // 察隅县应急指挥调度平台
  hrjcxs: 1070, // 怀柔区河道综合检查巡视项目系统
  xyhcgz: 1071, // 襄垣县农村户厕改造验收平台
  hdhjjs: 1073, // 海淀城市环境建设管理检查考评系统
  hhht: 1076, // 呼和浩特市生活垃圾分类考核系统
  qyzc: 1077, // 清研支持项目定制
  syljfl: 1078, // 沈阳垃圾分类考核系统
  syshlj: 1079, // 沈阳市农村生活垃圾检查系统
  sjshcz: 1080, // 石景山区河长制检查项目
  dljgpt: 1081, // 大连城管督导员监管平台,
  ynjg: 1082,
  ygwyzxm: 1260,
  ynjgqx: 1082,
  ynjgsq: 1082,
  ygwy: 1255, // 阳光物业
  myhzz: 1256, // 密云区水务局河长制项目
  lk: 1258, // “文明驾车 礼让行人”专项行动——路口测评
  fsqljflrcjc: 1286, // 2023年房山区垃圾分类日常检查
  ftcxhjzhjc: 1292, // 2023年丰台区城乡环境建设综合检查
}
// 正式环境项目id
const proAppId = {
  wz: 970, // 无证无照经营整治第三方核查项目
  zt: 976, // 西城区建筑垃圾协同管理执法系统(渣土)
  ugm: 957, // 北京市垃圾分类日常运行检查项目
  lhzf: 976, // 西城区建筑垃圾协同管理执法系统(联合执法)
  jzlj: 976, // 西城区建筑垃圾协同管理执法系统(联合执法)
  yyzcjc: 973, // 政策监测及政策数据库搭建项目(远洋)
  zrzh: 977, // 内蒙土默特右旗自然灾害风险普查系统
  ydspxj: 980, // 移动视频巡检
  // rzsb: 981, // 日志上报系统
  rzsb: 976, // 日志上报系统
  yldzhtgl: 978, // 北京市通州区永乐店镇合同管理系统
  cyhjjc: 982, // 朝阳环境检查项目
  ddqljfl: 985, // 大东区垃圾分类全链路智慧化管理平台
  cthcp: 986, // 密云区2023年文明城区创建检查整改系统
  dsfxcfw: 984, // 2021年疏解整治促提升第三方巡查服务
  wsjdjc: 987, // 北京市行业环境卫生监督检查-农村公厕
  lstl: 989, // 2022年莱绅通灵神访稽核项目
  syhjws: 988, // 沈阳市环境卫生监管系统
  cypystl: 991, // 朝阳区平原生态林检查项目（2022）
  cphczjc: 992, // 昌平区河长制检查
  sgwzdbg: 993, // 市管委自动报告
  dlljflxzsj: 994, // 大连市城市生活垃圾分类检查考核智慧管理平台(新增数据)
  hrwmcq: 995, // 怀柔区2022年创建全国文明城区项目
  wmcq: 996, // 西城区文明城区建设自检系统
  tyzrzh: 997, // 第一次自然灾害普查县级应用系统
  qjzhyl: 998, // 曲靖市智慧园林全体系工作管理平台
  jsjb: 999, // 接诉即办大数据分析服务其他专业技术服务采购项目
  qzewm: 1000, // 全总二维码
  'ljfl-xq': 1001, // 垃圾分类示范片区复验和部分示范片区二次验收服务-小区
  cyzxjc: 1002, // 2022年朝阳区环境专项检查
  zjzsjcpt: 1003, // 国际政界指数监测平台
  xcljfl: 1004, // 2022年西城区垃圾分类日常检查项目
  sjswmsjzx: 1006, // 石景山文明实践中心
  ljfldemo: 1007, // 清研垃圾分类全链路智慧管理平台
  jlljfl: 1008, // 净绿垃圾分类
  fwzljc: 1009, // （技术内部）2022年服务业服务质量监测评价项目
  zjzhgl: 1010, // 湛江市创建全国文明城市智慧管理项目
  'zjzhgl-wmsjzx': 1010, // 湛江市文明实践中心
  'zjzhgl-hrhs': 1010, // 湛江市道德模范与好人好事
  'zjzhgl-dwgl': 1010, // 湛江市单位管理
  hrjcxs: 1011, // 怀柔区河道综合检查巡视项目系统
  xyhcgz: 1012, // 襄垣县农村户厕改造验收平台
  xczhxc: 1013, // 西城区限额以下工程综合巡查管理系统
  hdhjjs: 1015, // 海淀城市环境建设管理检查考评系统
  hhht: 1018, // 呼和浩特市生活垃圾分类考核系统
  ftstl: 1017, // 丰台区生态林管护经营系统
  syljfl: 1019, // 沈阳垃圾分类考核系统
  syshlj: 1020, // 沈阳市农村生活垃圾检查系统
  sjshcz: 1053, // 石景山区河长制检查项目
  dljgpt: 1054, // 大连城管督导员监管平台
  ynjgqx: 1058,
  ynjgsq: 1058,
  myhzz: 1113, // 密云区水务局河长制项目
  fsqljflrcjc: 1196, // 2023年房山区垃圾分类日常检查
  ftcxhjzhjc: 1244, // 2023年丰台区城乡环境建设综合检查
}
// 登陆页key和appId映射
export const transformAppId =
  process.env.REACT_APP_DEP === 'dev' ? devAppId : proAppId

export const transformTplFromAppId =
  process.env.REACT_APP_DEP === 'dev'
    ? objectFlip(devAppId)
    : objectFlip(proAppId)

// 使用新登录方式的项目tpl
export const newLoginTypeTpls = [
  'ugm',
  'zrzh',
  'wbhjjc',
  'ydspxj',
  'yldzhtgl',
  'cyhjjc',
  'xcfz',
  'mggf',
  'ddqljfl',
  'mbyxm',
  'mbexm',
  'mbsxm',
  'cthcp',
  'dsfxcfw',
  'zjzsjcpt',
  'wsjdjc',
  'rzsb',
  'ddmpt',
  'filter',
  'lstl',
  'pgcxhjjs',
  'qjzhyl',
  'syhjws',
  'cypystl',
  'cphczjc',
  'sgwzdbg',
  'dlljfl',
  'dlljflxzsj',
  'zjzhgl',
  'tyzrzh',
  'hrwmcq',
  'tdqs',
  'tdqsback',
  'wmcq',
  'rxsq',
  'zjzhgl-wmsjzx',
  'zjzhgl-hrhs',
  'zjzhgl-dwgl',
  'jsjb',
  'cyzxjc',
  'qzewm',
  'ljfl-xq',
  'zzpczz',
  'lzzrzh',
  'xcljfl',
  'jlljfl',
  'sjswmsjzx',
  'gxdw',
  'ljfldemo',
  'fwzljc',
  'dbys',
  'xczhxc',
  'cyzhdd',
  'ftstl',
  'hrjcxs',
  'xyhcgz',
  'hdhjjs',
  'hhht',
  'qyzc',
  'syljfl',
  'syshlj',
  'sjshcz',
  'dljgpt',
  'ynjg',
  'ygwyzxm',
  'ynjgqx',
  'ynjgsq',
  'ygwy',
  'myhzz',
  'lk',
  'fsqljflrcjc',
  'ftcxhjzhjc',
]
